import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Valeurs d'enum de type de zone. Un nom de zone qui vaut EXACTEMENT l'une d'elles
 * n'est pas un vrai nom saisi par l'utilisateur (zones de test / héritées) → on
 * affiche plutôt le libellé localisé du type.
 */
const LOCATION_TYPE_VALUES = ['GARDEN', 'GREENHOUSE', 'PLANTER_BOX', 'INDOOR', 'TERRACE', 'BALCONY'];

/** Forme minimale d'une zone pour l'affichage de son nom. */
export interface ZoneLike {
  name?: string | null;
  locationType?: string | null;
}

/** Vrai si la zone porte un nom personnalisé (non vide ET différent d'une valeur brute d'enum). */
export function hasCustomZoneName(location?: ZoneLike | null): boolean {
  const name = location?.name?.trim();
  if (!name) return false;
  return !LOCATION_TYPE_VALUES.includes(name.toUpperCase());
}

/** Nom lisible d'une zone : le nom saisi s'il est personnalisé, sinon le libellé localisé du type. */
export function localizedZoneName(location: ZoneLike | null | undefined, translate: TranslateService): string {
  if (hasCustomZoneName(location)) return location!.name!.trim();
  const type = location?.locationType;
  return type ? translate.instant('common.location-types.' + type) : '';
}

/** `{{ zone | vwZoneName }}` → nom lisible de la zone (nom saisi ou libellé localisé du type). */
@Pipe({ name: 'vwZoneName', standalone: true })
export class ZoneNamePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(location?: ZoneLike | null): string {
    return localizedZoneName(location, this.translate);
  }
}

/** `@if (zone | vwHasCustomZoneName)` → masquer le libellé de type redondant quand le nom est déjà personnalisé. */
@Pipe({ name: 'vwHasCustomZoneName', standalone: true })
export class HasCustomZoneNamePipe implements PipeTransform {
  transform(location?: ZoneLike | null): boolean {
    return hasCustomZoneName(location);
  }
}
